// extracted by mini-css-extract-plugin
export default {"component":"TransferToOfficeModal_component__GeJ-5","modalContainer":"TransferToOfficeModal_modalContainer__T3sF4","input":"TransferToOfficeModal_input__Zmr8Q"};